import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dinamicvalues',
  templateUrl: './dinamicvalues.component.html',
  styleUrls: ['./dinamicvalues.component.css']
})
export class DinamicvaluesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
